<template>
  <!-- Observaciones -->
  <v-flex xs12 class="form-group observaciones">
    <vue-editor v-model="valueComputed" :editor-options="editorSettings" @change="observaciones" />
  </v-flex>
</template>
<script>
import { VueEditor, Quill } from "vue2-editor";
import { IndentStyle } from "@/helpers/quill-extensions";

export default {
  name: "TalentoObservaciones"
  , components: { VueEditor }
  , props: {
    talento: {
      default: undefined
      , type: Object
    }
  }
  , data() {
    return {
      value: this.talento ? this.talento.observacionesgen : ""
      , editorSettings: { modules: { toolbar: [[{ header: [1, 2, 3, 4, 5, 6, false] }], ["bold", "italic", { align: "" }, { align: "center" }, { align: "right" }]] } }
    };
  }
  , computed: {
    valueComputed: {
      get() {
        return this.value;
      }
      , set(value) {
        this.value = value;
      }
    }
  }
  , watch: {
    valueComputed: {
      handler() {
        if (this.valueComputed != null) this.observaciones();
      }
      , deep: true
    }
  }
  , methods: {
    init() {
      const AlignStyle = Quill.import("attributors/style/align");
      Quill.register(AlignStyle, true);
      Quill.register(IndentStyle, true);
    }
    , observaciones() {
      this.$emit("observaciones", this.value);
    }
  }
};
</script>

<style>
.observaciones .ql-editor {
  min-height: 100px !important;
  height: 90px !important;
  font-size: 16px;
}

.observaciones .ql-toolbar {
  background-color: white;
}

.observaciones .ql-container {
  background: rgba(0, 0, 0, 0.06);
}
</style>



// WEBPACK FOOTER //
// src/views/talento/TalentoObservaciones.vue